module.exports = __webpack_public_path__ + "static/media/color.ff37a738.jpg";